// externals
import { useSelector } from 'react-redux';

// selectors
import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';

// components
import { DeskingActivityDealMultiple } from './DeskingActivityDealMultiple';
import { ScenarioGrid } from '../scenarioGrid/ScenarioGrid';

export const DeskingActivityDeal = () => {
    const isScenarioGridActive = useSelector(scenarioGridSelectors.isScenarioGridActive);

    return isScenarioGridActive ? <ScenarioGrid /> : <DeskingActivityDealMultiple />;
};
